import React from 'react'

import lang from 'lang'
import CommonLayout from 'components/common-layout'
import Head from 'components/head'
import { wrapper } from 'common/store'
import Modal from 'common/components/modal'
import { requestHtmlContent } from 'common/services/html-content/actions'
import ExternalHtml from 'common/services/html-content/external-html'

export default class Terms extends React.Component {
  static getInitialProps = wrapper.getInitialPageProps((store) => ({ req }) => {
    store.dispatch(
      requestHtmlContent({
        req,
        keys: ['terms'],
      }),
    )
  })

  render() {
    return (
      <CommonLayout>
        <Head title={lang.tos} />
        <Modal />
        <style jsx>
          {`
            .hero-section {
              margin-bottom: 3rem;
            }
          `}
        </style>
        <div className="hero-section">
          <div className="grid-container">
            <p>
              <strong>{lang.aboutWebsites}</strong>
            </p>
            <ExternalHtml slug="terms" />
          </div>
        </div>
      </CommonLayout>
    )
  }
}
